module.exports = __webpack_public_path__ + "static/media/new-step-indicator-2.c25864a1.svg";